import { RoleSortOption } from '@rematter/frontend-lib-api-client';

import { RoleRecord, RoleStatus } from '../types';

import { createQueryHook } from '~/shared/providers/api';

export interface RolesQueryParams {
  searchTerm?: string;
  sorting?: RoleSortOption[];
  limit?: number;
  offset?: number;
  includeArchived?: boolean;
}

export interface RolesQueryResult {
  roles: RoleRecord[];
  total: number;
}

/**
 * Query hook for fetching roles for the Team & Permissions module.
 * Transforms role data into RoleRecord format.
 */
export const useRolesQuery = createQueryHook(
  'settings.teamPermissions.roles',
  (params: RolesQueryParams) => ({
    coreRoles: {
      __args: {
        filter: {
          searchTerm: params.searchTerm || undefined,
          sorting: params.sorting,
          includeArchived: params.includeArchived,
          pagination: {
            limit: params.limit ?? 20,
            offset: params.offset ?? 0,
          },
        },
      },
      entries: {
        id: true,
        name: true,
        archived: true,
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): RolesQueryResult => ({
      roles:
        data?.coreRoles.entries.map((role) => ({
          id: role.id,
          name: role.name,
          userCount: 0,
          status: (role.archived ? 'archived' : 'active') as RoleStatus,
        })) ?? [],
      total: data?.coreRoles.page.total ?? 0,
    }),
  },
);
